const initialState = {
  propertyResaleList: null,
  propertyResaleDetail: null,
  resaleInterestedPropertyList: null,
  assignedProject: null,
  marginHistory: null,

  arList: null,
  arView: null,
  reelsList: null,
  reelDetail: null,

  loading: false,
  listLoading: false,

  error: null,
  adminMarginError: null,

  adminMarginAdded: false,
  adminMarginUpdated: false,
  statusUpdated: false,
  interestedStatusUpdated: false,
  projectAssigned: false,

  vrAdded: false,
  vrRemoved: false,
  reelUploaded: false,

  arAdded: false,
  arUpdated: false,
  arDeleted: false,

  threeSixtyPrevVideoAdded: false,
  threeSixtyPrevVideoUpdated: false,

  reelsAdded: false,
  reelsUpdated: false,
};

export const propertyResaleReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LIST_PROPERTY_RESALE_REQUEST":
    case "LIST_RESALE_INTERESTED_PROPERTY_REQUEST":
    case "LIST_REELS_REQUEST":
      return {
        ...state,
        listLoading: true,
        error: null,
      };

    case "VIEW_PROPERTY_RESALE_REQUEST":
    case "STATUS_PROPERTY_RESALE_REQUEST":
    case "ADD_ADMIN_MARGIN_REQUEST":
    case "UPDATE_ADMIN_MARGIN_REQUEST":
    case "GET_MARGIN_HISTORY_REQUEST":
    case "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_REQUEST":
    case "ASSIGN_PROJECT_REQUEST":
    case "ADD_VR_REQUEST":
    case "REMOVE_VR_REQUEST":
    case "ADD_REEL_REQUEST":
    case "ADD_AR_REQUEST":
    case "LIST_AR_REQUEST":
    case "VIEW_AR_REQUEST":
    case "UPDATE_AR_REQUEST":
    case "DELETE_AR_REQUEST":
    case "ADD_THREE_SIXTY_PREV_VIDEO_REQUEST":
    case "UPDATE_THREE_SIXTY_PREV_VIDEO_REQUEST":
    case "ADD_REELS_REQUEST":
    case "UPDATE_REELS_REQUEST":
    case "VIEW_REELS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "LIST_PROPERTY_RESALE_SUCCESS":
      return {
        ...state,
        listLoading: false,
        propertyResaleList: action.payload,
        error: null,
      };

    case "LIST_PROPERTY_RESALE_FAILED":
      return {
        ...state,
        listLoading: false,
        error: action.payload,
      };

    case "VIEW_PROPERTY_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyResaleDetail: action.payload,
        error: null,
      };

    case "VIEW_PROPERTY_RESALE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "STATUS_PROPERTY_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        statusUpdated: true,
        error: null,
      };

    case "STATUS_PROPERTY_RESALE_FAILED":
      return {
        ...state,
        loading: false,
        statusUpdated: false,
        error: action.payload,
      };

    case "ADD_ADMIN_MARGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        adminMarginAdded: true,
        adminMarginError: null,
      };

    case "ADD_ADMIN_MARGIN_FAILED":
      return {
        ...state,
        loading: false,
        adminMarginAdded: false,
        adminMarginError: action.payload,
      };

    case "UPDATE_ADMIN_MARGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        adminMarginUpdated: true,
        adminMarginError: null,
      };

    case "UPDATE_ADMIN_MARGIN_FAILED":
      return {
        ...state,
        loading: false,
        adminMarginUpdated: false,
        adminMarginError: action.payload,
      };

    case "GET_MARGIN_HISTORY_SUCCESS":
      return {
        ...state,
        loading: false,
        marginHistory: action.payload.data,
        error: null,
      };

    case "GET_MARGIN_HISTORY_FAILED":
      return {
        ...state,
        loading: false,
        marginHistory: null,
        error: action.payload,
      };

    case "LIST_RESALE_INTERESTED_PROPERTY_SUCCESS":
      return {
        ...state,
        listLoading: false,
        resaleInterestedPropertyList: action.payload,
        error: null,
      };

    case "LIST_RESALE_INTERESTED_PROPERTY_FAILED":
      return {
        ...state,
        listLoading: false,
        error: action.payload,
      };

    case "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_SUCCESS":
      return {
        ...state,
        loading: false,
        interestedStatusUpdated: true,
        error: null,
      };

    case "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_FAILED":
      return {
        ...state,
        loading: false,
        interestedStatusUpdated: false,
        error: action.payload,
      };

    case "ASSIGN_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        assignedProject: action.payload,
        projectAssigned: true,
        error: null,
      };

    case "ASSIGN_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        projectAssigned: false,
        error: action.payload,
      };

    case "ADD_VR_SUCCESS":
      return {
        ...state,
        loading: false,
        vrAdded: true,
        error: null,
      };

    case "ADD_VR_FAILED":
      return {
        ...state,
        loading: false,
        vrAdded: false,
        error: action.payload,
      };

    case "REMOVE_VR_SUCCESS":
      return {
        ...state,
        loading: false,
        vrRemoved: true,
        error: null,
      };

    case "REMOVE_VR_FAILED":
      return {
        ...state,
        loading: false,
        vrRemoved: false,
        error: action.payload,
      };

    case "ADD_REEL_SUCCESS":
      return {
        ...state,
        loading: false,
        reelUploaded: true,
        error: null,
      };

    case "ADD_REEL_FAILED":
      return {
        ...state,
        loading: false,
        reelUploaded: false,
        error: action.payload,
      };

    case "ADD_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arAdded: true,
        error: null,
      };

    case "ADD_AR_FAILED":
      return {
        ...state,
        loading: false,
        arAdded: false,
        error: action.payload,
      };

    case "LIST_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arList: action.payload,
        error: null,
      };

    case "LIST_AR_FAILED":
      return {
        ...state,
        loading: false,
        arList: null,
        error: action.payload,
      };

    case "VIEW_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arView: action.payload,
        error: null,
      };

    case "VIEW_AR_FAILED":
      return {
        ...state,
        loading: false,
        arView: null,
        error: action.payload,
      };

    case "UPDATE_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arUpdated: true,
        error: null,
      };

    case "UPDATE_AR_FAILED":
      return {
        ...state,
        loading: false,
        arUpdated: false,
        error: action.payload,
      };

    case "DELETE_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arDeleted: true,
        error: null,
      };

    case "DELETE_AR_FAILED":
      return {
        ...state,
        loading: false,
        arDeleted: false,
        error: action.payload,
      };

    case "ADD_THREE_SIXTY_PREV_VIDEO_SUCCESS":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoAdded: true,
        error: null,
      };

    case "ADD_THREE_SIXTY_PREV_VIDEO_FAILED":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoAdded: false,
        error: action.payload,
      };

    case "UPDATE_THREE_SIXTY_PREV_VIDEO_SUCCESS":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoUpdated: true,
        error: null,
      };

    case "UPDATE_THREE_SIXTY_PREV_VIDEO_FAILED":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoUpdated: false,
        error: action.payload,
      };

    case "ADD_REELS_SUCCESS":
      return {
        ...state,
        loading: false,
        reelsAdded: true,
        error: null,
      };

    case "ADD_REELS_FAILED":
      return {
        ...state,
        loading: false,
        reelsAdded: false,
        error: action.payload,
      };

    case "UPDATE_REELS_SUCCESS":
      return {
        ...state,
        loading: false,
        reelsUpdated: true,
        error: null,
      };

    case "UPDATE_REELS_FAILED":
      return {
        ...state,
        loading: false,
        reelsUpdated: false,
        error: action.payload,
      };

    case "LIST_REELS_SUCCESS":
      return {
        ...state,
        listLoading: false,
        reelsList: action.payload,
        error: null,
      };

    case "LIST_REELS_FAILED":
      return {
        ...state,
        listLoading: false,
        reelsList: null,
        error: action.payload,
      };

    case "VIEW_REELS_SUCCESS":
      return {
        ...state,
        loading: false,
        reelDetail: action.payload,
        error: null,
      };

    case "VIEW_REELS_FAILED":
      return {
        ...state,
        loading: false,
        reelDetail: null,
        error: action.payload,
      };

    case "CLEAR_PROPERTY_RESALE_FLAGS":
      return {
        ...state,
        adminMarginAdded: false,
        adminMarginUpdated: false,
        statusUpdated: false,
        interestedStatusUpdated: false,
        projectAssigned: false,
        vrAdded: false,
        vrRemoved: false,
        reelUploaded: false,
        arAdded: false,
        arUpdated: false,
        arDeleted: false,
        threeSixtyPrevVideoAdded: false,
        threeSixtyPrevVideoUpdated: false,
        reelsAdded: false,
        reelsUpdated: false,
        error: null,
        adminMarginError: null,
      };

    case "STOP_LOADING":
      return {
        ...state,
        loading: false,
        listLoading: false,
      };

    default:
      return state;
  }
};